import React, { useEffect, useState } from 'react'
import Header from '../../Components/Header'
import { leftArrow, tableEye } from '../../common/Assets/imgs'
import { useLocation, useNavigate } from 'react-router-dom'
import MaterialTable from '../../Components/Table/MaterialTable'
import toast from 'react-hot-toast'
import { get, put } from '../../Services/ApiHandler'
import { URLS } from '../../Services/Constant'

const DriverTripHistory = () => {
  const navigation = useNavigate();
  const location = useLocation();
  const { type } = location.state || {};
  const [pagination, setPagination] = useState(1);
  const [totalCount, setTotalCount] = useState(1);
  const [loader, setLoader] = useState(false);
  const [driverDataState, setDriverDataState] = useState(null);

  const [adminList, setAdminList] = useState([]);

  console.log("datasdatas,,,", driverDataState);

  useEffect(() => {
    try {
      const data = sessionStorage.getItem('driverdata');
      if (data) {
        setDriverDataState(JSON.parse(data));
      }
    } catch (error) {
      console.error('Failed to parse driverData from sessionStorage:', error);
    }
  }, []);


  const getList = async () => {

    try {
      const response = await get(`${URLS.DRIVER_TRIP_LIST}${driverDataState?.id}/`);
      console.log("res", response);
      setAdminList(response?.data);
    } catch (error) {
      console.log("err", error);
    }
  };

  useEffect(() => {
    if (driverDataState?.id) {
      getList();
    }
  }, [driverDataState]);

  const columns = [
    {
      header: "S.No",
      accessorFn: (row, index) => index + 1,
      id: "serial_no",
    },
    {
      accessorKey: "order_id",
      header: "Order ID",
    },
    {
      accessorKey: "pickup",
      header: "Pickup",
        Cell: ({ row }) => {
        const text = row.original.pickup || "";
        return text.length > 20 ? text.substring(0, 20) + "..." : text;
      },
    },
    {
      accessorKey: "drop",
      header: "Drop",
        Cell: ({ row }) => {
        const text = row.original.drop || "";
        return text.length > 20 ? text.substring(0, 20) + "..." : text;
      },
    },
    {
      accessorKey: "total_amount",
      header: "Trip Price",
    },
    {
      accessorKey: "date_time",
      header: "Date & Time",
    },
    {
      header: "Status",
      accessorKey: "status",
      // Cell: ({ cell, row }) => {
      //   const status = cell.getValue();

      //   let statusClass = "";
      //   let statusText = "";

      //   if (status === "pending") {
      //     statusClass = "pending-btn";
      //     statusText = "Pending";
      //   } else if (status === "delivered") {
      //     statusClass = "delivered-btn";
      //     statusText = "Delivered";
      //   } else if (status === "completed") {
      //     statusClass = "completed-btn";
      //     statusText = "Completed";
      //   }

      //   return (
      //     <button
      //       className={`border-0 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13 ${statusClass}`}
      //     >
      //       {statusText}
      //     </button>
      //   );
      // },
    },

  ];


  const tabs = [
    { name: "Driver Details", path: "/adddrivers-transport" },
    { name: "Driver Trip History", path: "/drivers-triphistory" },
  ];

  const handleTabClick = (tab) => {
    navigation(tab.path, { state: { driverDataState, type } });
  };



  return (
    <>
      <Header />
      <div style={{ marginTop: "6rem", padding: "15px" }}>
        <div className="section">
          <h3 onClick={() => navigation(-1)} className="section-titlez">
            <img
              src={leftArrow}
              style={{ marginRight: 10 }}
              className="back-icon-arrow"
              alt=""
            />
            Vehicles
          </h3>
          {/* Tabs */}
          <div className="tabs mb-4 ms-3">
            {tabs.map((tab, index) => (
              <button
                key={index}
                onClick={() => handleTabClick(tab)}
                className={`tab-btn ${location.pathname === tab.path ? "active" : ""
                  }`}
              >
                {tab.name}
              </button>
            ))}

          </div>
        </div>

        <div>
          <MaterialTable rowCount={totalCount} pagination={pagination} columns={columns} data={adminList || []} setPagination={setPagination} loading={loader} />
        </div>

      </div>
    </>
  )
}

export default DriverTripHistory;